module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [(_vm.show('accomodation')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('accomodations', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/boenden')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "boende",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.accomodation')
  })) + "\n    "), (_vm.has('accomodations', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('accomodations', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && !_vm.add && !_vm.has('accomodations', true)) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra', false, true)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && !_vm.add && _vm.has('accomodations', true)) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1&delivery=1', false, true)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && _vm.add) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && _vm.add) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1&delivery=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skipass') && !_vm.has('products')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('skipasses', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/liftkort?quick=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "liftkort",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.skipass')
  })) + "\n    "), (_vm.has('skipasses', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('skipasses', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('school')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('skischools', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidskola/oversikt?type=group')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "skidskola",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.school')
  })) + "\n    "), (_vm.has('skischools', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('bikeschool')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('bikeschool', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/cykelskola/oversikt?type=group')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "biking-white",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: 'Cykelskola'
  })) + "\n    "), (_vm.has('bikeschools', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('activities')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('activities', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo(null, '/barn-bjornbusen-branas/')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "aktiviteter",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.childrenactivities')
  })) + "\n    "), (_vm.has('activities', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('activities', false)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c63627b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/CompletedBookings.vue
// module id = 1002
// module chunks = 0